angular.module('autoremind.dialogs', [])
    .controller('autoremind.dialogs.previewDialogController', ['$scope', '$uibModalInstance', '$timeout', 'data', 'accountService', 'messagesService', 'printService',
    function ($scope, $uibModalInstance, $timeout, data, accountService, messagesService, printService) {
        $scope.accountService = accountService;
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
        $scope.viewModel = {
            contentData: '',
            contentSource: '',
            messageType: data.messageType,
            isPreview: true //data.messageType === 'voice' ? false : true
        };
        // Map services to use in view
        $scope.messagesService = messagesService;
        $scope.printService = printService;
        var viewEmail = function (message) {
            var x2js = new X2JS();
            var jsonObj = x2js.xml2js(message); //data.messageContent );
            $scope.viewModel.contentData = jsonObj.message.html;
            $scope.viewModel.contentSource = message;
        };
        var viewSms = function (message) {
            $scope.viewModel.contentSource = message;
            var x2js = new X2JS();
            var jsonObj = x2js.xml2js(message);
            // in case of incoming messages, there is no XML so we need to display text as is it
            $scope.viewModel.contentData = jsonObj ? jsonObj.message.__text : message;
        };
        var viewVoice = function (messageData) {
            $scope.viewModel.contentSource = messageData.message;
            $scope.viewModel.contentData = messageData.messageUuid; //'b42e2a67-570a-11e6-9393-002590f0d08e';
        };
        var defineMessageByType = function (messageData) {
            switch (data.messageType) {
                case 'sms':
                    // When a patient sends a confirm SMS we'll reply with "you have succesfully confirmed..." and this will be the latest message (first in messageData list) - so we display the last in the list
                    viewSms(messageData[messageData.length - 1].message);
                    // NOTE: We could also look for the one wiht contenttype="relation:reminder"
                    break;
                case 'voice':
                    viewVoice(messageData[0]);
                    break;
                default:
                    viewEmail(messageData[0].message);
            }
        };
        var loadMessageById = function () {
            $scope.viewModel.loaded = false; // This will make sure the "No message..." text is displayed until data is loaded
            var request = null;
            if (data.isTrackingcode) {
                request = messagesService.getMessageContentByTrackingCode(data.messageId);
            }
            else {
                request = messagesService.getMessageContentByMessageUuid(data.messageId, data.messageType);
            }
            if (request !== null) {
                request.then(function (messageData) {
                    $scope.viewModel.loaded = true;
                    $scope.viewModel.messages = messageData;
                    if (messageData !== undefined && messageData.length > 0) {
                        $timeout(function () {
                            // Since we may get multiple recordings the UI should let the user select
                            defineMessageByType(messageData);
                        });
                    }
                });
            }
        };
        if (typeof data.message !== 'undefined' && data.message !== '') {
            defineMessageByType(data.message);
        }
        else {
            loadMessageById();
        }
        $scope.changeView = function (isPreview) {
            $scope.viewModel.isPreview = isPreview;
        };
    }])
    .controller('autoremind.dialogs.confirmEditingTemplateController', ['$scope', '$uibModalInstance', '$timeout', 'data', function ($scope, $uibModalInstance, $timeout, data) {
        $scope.data = data;
        console.log('$scope.data', $scope.data);
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
        $scope.overwrite = function () {
            $uibModalInstance.close();
        };
    }])
    .controller('autoremind.dialogs.AdaptiveRulesController', ['$scope', '$uibModalInstance', '$timeout', 'data', 'logger', function ($scope, $uibModalInstance, $timeout, data, logger) {
        $scope.data = data;
        $scope.dialog = $uibModalInstance;
    }]);
//# sourceMappingURL=dialogs.controllers.js.map